import * as Sentry from "@sentry/react";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import { notification } from "antd";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any) => {
      Sentry.captureException(error);
      notification.error({
        title: error?.message || "Failed",
        placement: "top",
      });
    },
  }),

  defaultOptions: {
    queries: {
      retry:
        Number(
          window._env_?.VITE_REACT_QUERY_RETRY_NUMBER ||
            import.meta.env.VITE_REACT_QUERY_RETRY_NUMBER
        ) ?? 3,
      gcTime:
        Number(
          window._env_?.VITE_REACT_QUERY_GC_TIME ||
            import.meta.env.VITE_REACT_QUERY_GC_TIME
        ) ?? 1000 * 60 * 60 * 24,
      staleTime:
        Number(
          window._env_?.VITE_REACT_QUERY_STALE_TIME ||
            import.meta.env.VITE_REACT_QUERY_STALE_TIME
        ) ?? 1000 * 60 * 5,
      networkMode:
        window._env_?.VITE_REACT_QUERY_NETWORK_MODE ||
        import.meta.env.VITE_REACT_QUERY_NETWORK_MODE ||
        "online",
      retryDelay: (attempt) => attempt * 1000,
    },
    mutations: {
      onError: (error: unknown) => {
        Sentry.captureException(error);
      },
    },
  },
});

declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__?: import("@tanstack/query-core").QueryClient;
  }
}

if (import.meta.env.DEV) {
  window.__TANSTACK_QUERY_CLIENT__ = queryClient;
}
